module.exports = __webpack_public_path__ + "static/gallery-2-8e02b55e8fe0671a7e6c9110720f3960.jpeg";